'use client'

import React, { useState } from 'react'
import { Avatar, Button, cn, Spinner } from '@nextui-org/react'

import CellWrapper from './cell-wrapper'
import { Icon } from '@iconify/react'

export type UserCellProps = React.HTMLAttributes<HTMLDivElement> & {
  avatar: string
  name: string
  email: string
  permission: string
  showDeleteButton?: boolean
  onDeletePress?: () => Promise<void>
}

const UserCell = React.forwardRef<HTMLDivElement, UserCellProps>(
  ({ avatar, name, email, permission, className, showDeleteButton, onDeletePress, ...props }, ref) => {
    const [isDeleting, setIsDeleting] = useState<boolean>(false)
    const onClick = async () => {
      setIsDeleting(true)
      await onDeletePress?.()
      setIsDeleting(false)
    }
    return (
      <CellWrapper
        ref={ref}
        className={cn('bg-transparent px-3 py-1', className, isDeleting && 'opacity-40 cursor-wait')}
        {...props}
      >
        <div className="flex flex-1 items-center gap-2">
          {isDeleting && <Spinner size="sm" color="primary" />}
          <Avatar size="sm" showFallback name={name} />
          <div className="flex flex-col">
            <p className="text-small text-default-800">{name}</p>
            <p className="text-tiny text-default-500">{email}</p>
          </div>
        </div>
        <div className="flex flex-row items-center gap-2">
          <p className="text-small text-default-400">{permission}</p>
          {showDeleteButton && (
            <Button variant="light" onPress={onClick}>
              <Icon icon={'lucide:trash'} color={'#EE4B2B'} />
            </Button>
          )}
        </div>
      </CellWrapper>
    )
  },
)

UserCell.displayName = 'UserCell'

export default UserCell
